import React from "react";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withLocalize, Translate } from "react-localize-redux";
import { isOnPath } from "../../store/apiWrapper";
import { getLanguage } from "../../store/storeFunctions";

class PanelItem extends React.Component {
    render() {
        let id = `lp-tooltip${this.props.p.link.replace(/\//g, "-")}`;
        const hasPerm = this.props.p.canShow();

        return (
            <li className="menu-item">
                {hasPerm && this.renderWithLink(id)}
                {!hasPerm && this.renderWithRedirect(id)}
            </li>
        )
    }

    renderWithLink = (id) => {
        let { filter, label, link } = this.props.p;

        return (
            <Link key={id} className="panel-item" 
                to={{ pathname: link, state: { reset: true } }} style={{order:0}}
                data-active="1" data-on-link={isOnPath(filter) ? '1' : '0'}
            >
                {this.renderFirstIcon(id, label)}
                <div className="text-wrapper" style={{ marginTop: this.props.isFixed ? 0 : -this.props.scrollTop }}>
                    <div className="text" >
                        <div className="span-wrapper">
                            <span>{ReactHtmlParser(this.props.translate(`LeftPanel.${label}`))}</span>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }

    renderWithRedirect = (id) => {
        let { filter, label, redirectSk, redirectCz, redirectCzEn } = this.props.p;
        const linkStyle = {
            order: "1",
            backgroundSize: `auto ${this.getPanelHeight()}px`, 
            backgroundPosition: `center ${this.itemEl ? 0 - this.itemEl.offsetTop : 0}px`
        };
        const language = getLanguage();
        const isEn = language === 'en-US' || language === 'de-DE';
        const redirect = this.props.isSk ? `https://www.cribis.sk/${redirectSk}` : `https://www.mcribis.cz/${isEn ? redirectCzEn : redirectCz}`;

        return (
            <div key={id} className="panel-item" style={linkStyle}
                data-active="0"
                data-on-link={isOnPath(filter) ? '1' : '0'}
            >
                {this.renderFirstIcon(id, label)}
                <div ref={(el) => this.UnactiveText = el} className="text-wrapper" style={{ backgroundSize: `auto ${this.getPanelHeight()}px`, backgroundPosition: `center ${this.getBackgroundPosition()}px`, marginTop: this.props.isFixed ? 0 : -this.props.scrollTop, bottom: this.checkClientHeight() ? 0 : 'auto' }}>
                    <div className="text" style={{ backgroundSize: `auto ${this.getPanelHeight()}px`, backgroundPosition: `center ${this.itemEl ? 0 - this.itemEl.offsetTop + this.props.scrollTop : 0}px` }}>
                        <div className="span-wrapper">
                            <span>{ReactHtmlParser(this.props.translate(`LeftPanel.${label}`))}</span>
                        </div>
                        <div className="p-wrapper">
                            <p>{ReactHtmlParser(this.props.translate(`LeftPanel.Description.${label}`))}</p>
                        </div>
                        <a href={redirect} target="_blank" ><Translate id={"Common.MoreInformation"} /></a>
                    </div>
                </div>
            </div>
        );
    }

    renderFirstIcon = (id, label) => {
        let { icon } = this.props.p;
        return (
            <div ref={(el) => this.itemEl = el} className="icon-holder" id={id}>
                <div className={classnames('icon-wrap', {'is-square': localStorage.locales_menu_active_style === 'square'})}>
                    {icon({ className: 'svg-standard-fill' })}
                </div>
                <span className='icon-short-description'><Translate id={`LeftPanel.Short.${label}`} options={{ renderInnerHtml: true }} /></span>
            </div>
        );
    }

    getPanelHeight() {
        return (((this.props.panelHolder || {}).parentElement || {}).clientHeight) || 0;
    }

    checkClientHeight() {
        if (this.itemEl) {
            var panelItem = this.itemEl.parentElement;
            if (panelItem) {
                var leftPanelInner = panelItem.offsetParent;
                if (leftPanelInner)
                    return this.UnactiveText && ((this.itemEl.offsetTop + this.UnactiveText.clientHeight - leftPanelInner.scrollTop) >= this.getPanelHeight())
            }
        }
        return false
    }

    getBackgroundPosition() {
        var height = this.itemEl ? 0 - this.itemEl.offsetTop + this.props.scrollTop : 0;
        if (!this.UnactiveText)
            return height;
        if (height - this.UnactiveText.clientHeight < 0 - this.getPanelHeight())
            height = 0 - (this.UnactiveText ? (this.getPanelHeight() - this.UnactiveText.clientHeight) : 0);
        return height;
    }
}

export default withLocalize(connect(
    state => { return { layout: state.layout } },
    null
)(PanelItem));